/* eslint-disable array-callback-return */
/* eslint-disable no-empty */

import { all, call, put, takeLatest, select } from "redux-saga/effects";
import { mapValues, differenceBy } from "lodash";
import { cloneDeep } from "../../utils/cloneDeep";
import { CONTINUE, SAVE, EMAIL_IDENTIFIERS } from "../../constants";
import {
  SEND_ADHOC_AUTHORIZATION,
  sendAuthorizationSuccess,
  sendAuthorizationFail
} from "../actions/sendAdhocEmail";
import { sendAdhocEmail } from "../../api/apiClient";
import { log } from "../../utils/loggger";
import {
  getAuthorizationHeader,
  getProspectId,
  getProspect,
  getAdditionalDocumentsModel
} from "../selectors/appConfig";
import { sendProspectToAPI } from "./sendProspectToAPI";
import { updateProspect } from "../actions/appConfig";

export function* sendAdhocEmailSaga({ payload: { data, documents = [] } }) {
  try {
    const state = yield select();
    const prospectId = yield select(getProspectId);
    const additionalDocumentsModel = yield select(getAdditionalDocumentsModel);
    const headers = getAuthorizationHeader(state);
    let newProspect = cloneDeep(yield select(getProspect));
    const existingStakeholdersAdditionalDocs =
      newProspect.documents.additionalDocuments.stakeholdersDocuments;

    const { emailIdentifier, signatoryId } = data;
    if (emailIdentifier === EMAIL_IDENTIFIERS.CustAddDocSubmit) {
      let signatory = newProspect.signatoryInfo.find(
        signatory => signatory.signatoryId === signatoryId
      );
      signatory.additonalDocUploaded = true;
    } else {
      const { emailList } = data;
      let sidArr = [];
      emailList.forEach(email => {
        newProspect.signatoryInfo.forEach((signatory, signatoryIndex) => {
          if (email === signatory.contactDetails.preferredEmail) {
            signatory.additonalDocUploaded = false;
            sidArr.push(signatoryIndex + "_" + signatory.signatoryId);
          }
        });
      });
      const { stakeholdersDocuments, companyDocuments = [] } = additionalDocumentsModel;
      const newStakeholdersDocuments = mapValues(
        stakeholdersDocuments,
        (stakeHolder, stakeHolderIndex) => {
          if (sidArr.includes(stakeHolderIndex)) {
            const existDocs =
              existingStakeholdersAdditionalDocs &&
              existingStakeholdersAdditionalDocs[stakeHolderIndex] &&
              existingStakeholdersAdditionalDocs[stakeHolderIndex].documents
                ? existingStakeholdersAdditionalDocs[stakeHolderIndex].documents
                : [];

            const newDocs = [...stakeHolder.documents, ...companyDocuments].filter(doc => {
              if (documents.includes(doc.uniqueId)) {
                return doc;
              }
            });
            const addDocsDiff = differenceBy(newDocs, existDocs, "uniqueId");
            let mergedDocs = [...existDocs, ...addDocsDiff];
            return {
              ...stakeHolder,
              documents: mergedDocs
            };
          } else {
            return existingStakeholdersAdditionalDocs &&
              existingStakeholdersAdditionalDocs[stakeHolderIndex]
              ? existingStakeholdersAdditionalDocs[stakeHolderIndex]
              : {
                  ...stakeHolder,
                  documents: []
                };
          }
        }
      );

      const additionalDocuments = {
        companyDocuments: [],
        stakeholdersDocuments: newStakeholdersDocuments
      };

      newProspect.documents.additionalDocuments = additionalDocuments;
    }

    const action = { payload: { saveType: CONTINUE, actionType: SAVE, newProspect, step: null } };
    const errorResponse = yield call(sendProspectToAPI, action);

    if (errorResponse) {
      yield put(sendAuthorizationFail({}));
    } else {
      yield call(sendAdhocEmail.sendMail, data, headers, prospectId);
      yield put(updateProspect({ prospect: newProspect }));
      yield put(sendAuthorizationSuccess());
    }
  } catch (error) {
    yield put(sendAuthorizationFail({}));
    log(error);
  }
}

export default function* sendAdhocEmailSagas() {
  yield all([takeLatest(SEND_ADHOC_AUTHORIZATION, sendAdhocEmailSaga)]);
}
